import { Platform, QBtn, QInput, QSelect, QTooltip } from 'quasar'

function setQuasarComponentDefaultPropValues (component, propDefaults) {
  for (const key in propDefaults) {
    const prop = component.props[key]
    switch (typeof prop) {
      case 'object':
        prop.default = propDefaults[key]
        break
      case 'function':
        component.props[key] = {
          type: prop,
          default: propDefaults[key]
        }
        break
      case 'undefined':
        throw new Error('unknown prop: ' + key)
      default:
        throw new Error('unhandled type: ' + typeof prop)
    }
  }
}

setQuasarComponentDefaultPropValues(QBtn, {
  unelevated: true,
  outline: false
})

setQuasarComponentDefaultPropValues(QInput, {
  outlined: true,
  stackLabel: true,
  color: 'grey'
})

setQuasarComponentDefaultPropValues(QSelect, {
  outlined: true,
  stackLabel: true,
  color: 'grey'
})

setQuasarComponentDefaultPropValues(QTooltip, {
  anchor: Platform.has.touch ? 'top middle' : 'bottom middle',
  self: Platform.has.touch ? 'bottom middle' : 'top middle'
})
